var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDd3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 23.2666H23.0667V19.2666H24.4V16.6L23.0667 9.93329H3.06666L1.73332 16.6V19.2666H3.06666V27.2666H15.0667V19.2666H20.4V23.2666ZM12.4 24.6H5.73332V19.2666H12.4V24.6ZM3.06666 5.93329H23.0667V8.59996H3.06666V5.93329Z",
    fill: "#A9CF4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0667 24.6V20.6H24.4V24.6H20.4V27.2666H24.4V31.2666H27.0667V27.2666H31.0667V24.6H27.0667Z",
    fill: "#A9CF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDd3);
export default __webpack_public_path__ + "static/media/dd-3.55f0f7db44412cab27bc7b4aca7ffad4.svg";
export { ForwardRef as ReactComponent };